import * as React from 'react';

import FameRow from 'components/molecules/Fame/Row';
import ProgressPoints from 'components/molecules/ProgressPoints';

import { FameRowUnitType } from 'components/molecules/Fame/Row/FameRow';

export const FAME_PROCESS_MODIFIER = {
	todo: 'todo',
	recipe: 'recipe',
	workout: 'workout',
	tip: 'tip',
	task: 'task',
	overall: 'overall',
};

export const FameProcessModifier = {
	todo: 'todo',
	recipe: 'recipe',
	workout: 'workout',
	tip: 'tip',
	task: 'task',
	overall: 'overall',
};

export type FameProcessModifierType = keyof typeof FAME_PROCESS_MODIFIER | any;

type FameProgressPointsProps = {
	modifier: string; // FameProcessModifier;
	current: number;
	label: string;
	sticker?: string;
	progress: number;
	record?: Object;
	actual?: Object;
	overlap: boolean;
	steps?: Array<{ active?: boolean; number: number; percent: number }>;
	unit?: FameRowUnitType;
	badges: {
		intro?: string;
		list: any[];
	};
};

export type FameProgressProps = {
	title: string;
	text: string;
	progress: FameProgressPointsProps[];
	addition?: any;
};

export const getHighestPoints = (progress: FameProgressPointsProps): number => {
	const badges = progress.badges.list || new Array(3).fill({});
	let maxStep = 0;

	badges.forEach((badge) => {
		const intStepNumber = badge && badge.attributes ? parseInt(badge.attributes.threshold, 10) : 0;

		if (maxStep < intStepNumber) {
			maxStep = intStepNumber;
		}
	});

	return maxStep;
};

export const getStepsFromBadges = (progress: FameProgressPointsProps): Array<Object> => {
	const badges = progress.badges.list || new Array(3).fill({});
	let maxStep = 0;
	const progressSteps: number[] = [];

	badges.forEach((badge) => {
		const intStepNumber =
			badge && badge.attributes && badge.attributes.threshold && !isNaN(parseInt(badge.attributes.threshold, 10))
				? parseInt(badge.attributes.threshold, 10)
				: 0;

		if (maxStep < intStepNumber) {
			maxStep = intStepNumber;
		}

		progressSteps.push(intStepNumber);
	});

	return progressSteps.map((amount: number) => {
		return {
			active: !!(progress.current >= amount),
			number: amount,
			percent: (100 / maxStep) * amount,
		};
	});
};

const FameProgress = ({ title, text, progress = [], addition }: FameProgressProps) => {
	return (
		<div className="m-fame-progress">
			<div className="container">
				<div className="row">
					<div className="col-xs-12">
						<div className="m-fame-progress__info">
							<h2 className="m-fame-progress__title">{title}</h2>
							{addition && (
								<div className="m-fame-progress__addition">
									<span className="m-fame-progress__addition-value">{addition.value}</span>
									<span className="m-fame-progress__addition-label">{addition.text}</span>
								</div>
							)}
							<p className="m-fame-progress__text">{text}</p>
						</div>
					</div>
				</div>
			</div>

			{progress &&
				progress.map((prog: FameProgressPointsProps, index: number) => {
					return (
						<div key={index}>
							<div className="container">
								<div className="row">
									<div className="col-xs-12">
										<div className="m-fame-progress__wrapper">
											<div className="m-fame-progress__points">
												<ProgressPoints
													modifier={prog.modifier}
													current={prog.current}
													max={getHighestPoints(prog)}
													label={prog.label}
													sticker={prog.sticker ? prog.sticker : ''}
													progress={prog.progress}
													record={prog.record as any}
													actual={prog.actual as any}
													overlap={prog.overlap}
													steps={getStepsFromBadges(prog) as any}
												/>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="m-fame-progress__row">
								<FameRow
									topic={prog.modifier as any}
									intro={prog.badges.intro}
									badges={prog.badges.list}
									unit={prog.unit}
									current={prog.current}
									max={getHighestPoints(prog)}
								/>
							</div>
						</div>
					);
				})}
		</div>
	);
};

export default FameProgress;
